export const API_BASE = '/api';

export const ENDPOINTS = {
  authConfig: `${API_BASE}/auth/config`,
  health: `${API_BASE}/health`,
  billingStatus: `${API_BASE}/billing/status`,
  billingCheckout: `${API_BASE}/billing/checkout`,
  billingPortal: `${API_BASE}/billing/portal`,
  billingOneTimePurchase: `${API_BASE}/billing/one-time-purchase`,
  billingHistory: `${API_BASE}/billing/history`,
  networkStats: `${API_BASE}/wager-board/stats`,
  latestBelief: `${API_BASE}/wager-board/feed?limit=1`,
  rewardPools: `${API_BASE}/reward-pools`,
  unifiedFeed: `${API_BASE}/feed/unified`,
  scheduleStats: `${API_BASE}/schedules/stats`,
  publicSchedules: `${API_BASE}/schedules/public`,
  scheduleFeed: `${API_BASE}/schedules/feed`,
  topics: `${API_BASE}/topics`,
  tiers: `${API_BASE}/tiers`,
  me: `${API_BASE}/me`,
  singularityConsensus: `${API_BASE}/singularity/consensus`,
  recommendationsFeatured: `${API_BASE}/recommendations/featured`,
  oauthComplete: '/oauth/complete',
} as const;

// Dynamic endpoints (need ID interpolation)
export const entityProfile = (id: string): string => `${API_BASE}/entities/public/${id}/profile`;
export const entityDIS = (id: string): string => `${API_BASE}/entities/${id}/dis`;
export const entityGlyph = (id: string): string => `${API_BASE}/entities/${id}/glyph`;
export const entityBeliefEvolution = (id: string): string => `${API_BASE}/entities/${id}/belief-evolution`;
export const entityConverseAvailability = (id: string): string => `${API_BASE}/entities/${id}/converse/availability`;
export const entityConverse = (id: string): string => `${API_BASE}/entities/${id}/converse`;
export const wagerDetail = (id: string): string => `${API_BASE}/wagers/public/${id}`;
export const wagerPosts = (id: string): string => `${API_BASE}/wagers/${id}/posts`;
export const wagerPrompts = (id: string): string => `${API_BASE}/wagers/${id}/prompts`;
export const projectDetail = (id: string): string => `${API_BASE}/projects/${id}`;
export const projectPosts = (id: string): string => `${API_BASE}/projects/${id}/posts`;
export const topicDetail = (id: string): string => `${API_BASE}/topics/${id}`;
export const topicPosts = (id: string): string => `${API_BASE}/topics/${id}/posts`;
export const sessionRun = (scheduleId: string, runId: string): string => `${API_BASE}/schedules/${scheduleId}/runs/${runId}`;
export const entityTimeline = (id: string): string => `${API_BASE}/entities/${id}/timeline`;
